import styled from 'styled-components'
import { InnerCircleProps, OuterCircleProps } from './types'

export const SVG = styled.svg<{ radius: number }>`
	height: ${props => props.radius * 2}px;
	width: ${props => props.radius * 2}px;
`

export const OuterCircle = styled.circle<OuterCircleProps>`
	stroke: ${props => props.color};
	fill: transparent;
	stroke-width: ${props => props.stroke}px;
`

export const InnerCircle = styled(OuterCircle)<InnerCircleProps>`
	transform-origin: center;
	transform: rotate(-90deg);
`
